import { render, staticRenderFns } from "./pictureQuestionAnswer.vue?vue&type=template&id=0ab1b126&scoped=true&"
import script from "./pictureQuestionAnswer.vue?vue&type=script&lang=js&"
export * from "./pictureQuestionAnswer.vue?vue&type=script&lang=js&"
import style0 from "./pictureQuestionAnswer.vue?vue&type=style&index=0&id=0ab1b126&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab1b126",
  null
  
)

export default component.exports